import { render, staticRenderFns } from "./CreateWidgetTemplateDlg.vue?vue&type=template&id=51c3e208"
import script from "./CreateWidgetTemplateDlg.vue?vue&type=script&lang=ts"
export * from "./CreateWidgetTemplateDlg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports